module.exports = __webpack_public_path__ + "static/tada-499fb6ab3515d1fb276b23d82927bc45.wav";